import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'; // Import HttpClient
import { environment } from 'src/environments/environment'; // Adjust path based on your project structure

@Injectable({
  providedIn: 'root'
})
export class MyOrdersService {

  constructor(private _http: HttpClient) { } // Inject HttpClient

  getBookingConfirmedOrders(filter: any) {
    return this._http.post(environment.apiUrl + 'api/cstmr/get-customer-orders-for-dashboard-web', filter);
  }
}
